import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOutgoingEmail = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	focusable: "false",
	"aria-hidden": "true",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2H4V8l8 5 8-5v5h2V6c0-1.1-.9-2-2-2m-8 7L4 6h16zm7 4 4 4-4 4v-3h-4v-2h4z" })
});
export default SvgOutgoingEmail;
